import SnowTheme from 'quill/themes/snow';

class StashTextEditorSnowTheme extends SnowTheme {
  // overwrite buildButtons method to prevent quill theme from building the buttons
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  buildButtons(_: NodeListOf<HTMLElement>, __: Record<string, Record<string, string> | string>) {}
}

export default StashTextEditorSnowTheme;
